import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { filter } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LanguageService } from '../../core/services/language.service';
import { DialogService } from '../../osp-ui/services/dialog.service';
import { EquipmentDialogService } from '../../pages/resources/equipment/equipment-dialog/services/equipment-dialog.service';
import { EntityCreateDialogComponent } from '../components/entity-create-dialog/entity-create-dialog.component';
import { DIALOG_ACTION, DialogResult } from '../contract/dialog-result.contract';
import { AssetType } from '../enums/asset-type.enum';

@Injectable({ providedIn: 'root' })
export class EntityCreateControllerService {
  private readonly dialogService = inject(DialogService);
  private readonly languageService = inject(LanguageService);
  private readonly equipmentDialogService = inject(EquipmentDialogService);
  private readonly router = inject(Router);

  private readonly DIALOG_WIDTH = '1200px';
  private readonly createEntityMap: Partial<Record<AssetType, () => void>> = {
    [AssetType.EQUIPMENT]: () =>
      this.openCreationForm({
        entityDialogService: this.equipmentDialogService,
        postCreateAction: (entityId) => {
          void this.router.navigate([`/resources/equipment/${entityId}`]);
        },
      }),
  };

  createNewEntity(): void {
    this.dialogService
      .open(EntityCreateDialogComponent, {
        header: this.languageService.getInstant('shared.createEntity.header'),
        width: this.DIALOG_WIDTH,
      })
      .onClose.pipe(filter(Boolean))
      .subscribe((res: AssetType) => this.createEntityMap[res]?.());
  }

  private openCreationForm(config: {
    entityDialogService: { open: () => DynamicDialogRef };
    postCreateAction: (entityId: string) => void;
  }): void {
    config.entityDialogService
      .open()
      .onClose.pipe(filter(Boolean))
      .subscribe((result: DialogResult<string>) => this.handleDialogResult(result, config.postCreateAction));
  }

  private handleDialogResult(result: DialogResult<string>, postCreateAction: (entityId: string) => void): void {
    switch (result.action) {
      case DIALOG_ACTION.GO_BACK:
        this.createNewEntity();
        break;
      case DIALOG_ACTION.SAVE:
        if (result.payload) {
          setTimeout(() => postCreateAction(result.payload!), environment.DELAY_SHORTEST);
        }
        break;
      default:
        break;
    }
  }
}
